import { useTranslation } from 'react-i18next';

import { BlueContainer, Paragraph } from '@app/shared/ui/atoms/Common';

export const DescriptionSection = () => {
  const { t } = useTranslation();

  return (
    <section className="px-5">
      <BlueContainer>
        <Paragraph className="text-center">{t('daily_card_preview.description')}</Paragraph>
      </BlueContainer>
    </section>
  );
};
